import React from 'react';
import { SkeletonBlock } from '../../../components/skeleton/skeleton';

export default function UsersSkeleton({ rows = 8 }) {
  return (
    <div className="reveal" aria-hidden="true">
      <table className="min-w-full divide-y divide-gray-300 dark:divide-slate-500">
        <thead>
          <tr>
            <th className="py-3.5 pr-3 text-left text-sm font-semibold text-slate-900 dark:text-slate-100">
              Name
            </th>
            <th className="py-3.5 px-4 text-left text-sm font-semibold text-slate-900 dark:text-slate-100">
              Email
            </th>
            <th className="py-3.5 px-4 text-left text-sm font-semibold text-slate-900 dark:text-slate-100">
              Role
            </th>
            <th className="py-3.5 px-4 text-left text-sm font-semibold text-slate-900 dark:text-slate-100">
              Status
            </th>
            <th className="py-3.5 px-4 text-right">
              <span className="sr-only">Actions</span>
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-200 dark:divide-slate-500">
          {[...Array(rows)].map((_, idx) => (
            <tr key={idx}>
              <td className="whitespace-nowrap py-4 pr-3">
                <SkeletonBlock className="h-4 w-36 rounded" />
              </td>
              <td className="whitespace-nowrap px-4 py-4">
                <SkeletonBlock className="h-4 w-48 rounded" />
              </td>
              <td className="whitespace-nowrap px-4 py-4">
                <SkeletonBlock className="h-4 w-28 rounded" />
              </td>
              <td className="whitespace-nowrap px-4 py-4">
                <SkeletonBlock className="h-6 w-16 !rounded-full" />
              </td>
              <td className="whitespace-nowrap px-4 py-4">
                <div className="flex justify-end gap-2">
                  <SkeletonBlock className="h-8 w-8 !rounded-full" />
                  <SkeletonBlock className="h-8 w-8 !rounded-full" />
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="mt-4 flex w-full items-center justify-between gap-3">
        <SkeletonBlock className="h-4 w-56 max-w-full rounded" />
        <SkeletonBlock className="h-8 w-64 max-w-full rounded-md" />
      </div>
    </div>
  );
}
